import styled from 'styled-components/macro';


const Content = styled.div`
    flex: 1 1 100%;
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
`;


export default Content;
